import { useLayoutEffect } from "react";

/**
 * Locks the body scroll when the hook is mounted.
 *
 * @example
 * ```tsx
 * const Component = () => {
 * useLockBodyScroll();
 *
 * return <div>Locked body scroll</div>;
 * };
 * ```
 */
export const useLockBodyScroll = () => {
	useLayoutEffect(() => {
		const originalStyle = window.getComputedStyle(document.body).overflow;
		document.body.style.overflow = "hidden";
		return () => {
			document.body.style.overflow = originalStyle;
		};
	}, []);
};
